<script setup lang="ts">
import { computed, type HTMLAttributes } from "vue";

import { cn } from "../../lib/utils";

type BadgeVariant = "accent" | "neutral" | "outline";

interface Props {
  variant?: BadgeVariant;
  class?: HTMLAttributes["class"];
}

const props = withDefaults(defineProps<Props>(), {
  variant: "accent"
});

const computedClass = computed(() =>
  cn("ui-badge", `ui-badge--${props.variant}`, props.class)
);
</script>

<template>
  <span :class="computedClass">
    <slot />
  </span>
</template>
